import { ref } from 'vue';

const isCollapsed = ref(false);

export function useSidebarState() {
  const toggleSidebar = (): void => {
    isCollapsed.value = !isCollapsed.value;
  };

  const setSidebarCollapsed = (value: boolean): void => {
    isCollapsed.value = value;
  };

  return {
    isCollapsed,
    toggleSidebar,
    setSidebarCollapsed,
  };
}
